module.exports = __webpack_public_path__ + "img/image-labels-3-d-mobile.0132fb3d.png";